import { trackBusinessError } from '@sxm-de/dev-kits/web-sdk/utils';
import { DependenciesPayload } from '@sxm-de/dev-kits/web-sdk/types';

export async function updatePhoneNumber(
    { phoneNumber }: { phoneNumber: string },
    { clientSdk, appEventSdk }: DependenciesPayload,
) {
    try {
        await clientSdk.user.updatePhoneNumber({ phoneNumber });
    } catch (error: any) {
        if (
            (error as { code: string })?.code ===
            'userServices.identity.invalidPhoneNumber'
        ) {
            trackBusinessError(appEventSdk, error);
            throw new Error('INVALID_PHONE_NUMBER');
        } else {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    }
}
